<template>
	<div class="app-container">
		<!-- 搜索过滤 -->
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新建产品
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="产品名称">
					<el-input v-model="filterForm.name" placeholder="请输入产品名称" clearable @keyup.enter="handleSearch" />
				</el-form-item>
				<!-- <el-form-item label="产品类型">
          <el-select v-model="filterForm.type" placeholder="请选择产品类型" clearable>
            <el-option label="硬件" value="hardware" />
            <el-option label="软件" value="software" />
            <el-option label="服务" value="service" />
          </el-select>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon> 搜索
					</el-button>
					<el-button @click="resetForm">
						<el-icon>
							<Refresh />
						</el-icon> 重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 产品列表 -->
		<el-card class="table-card">
			<el-table :data="productList" height="calc(100vh - 320px)" style="width: 100%" stripe v-loading="loading">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="name" label="产品名称" />
				<!-- <el-table-column prop="type" label="产品类型">
          <template #default="scope">
            <el-tag :type="getProductTypeTag(scope.row.type)">
              {{ getProductTypeText(scope.row.type) }}
            </el-tag>
          </template>
        </el-table-column> -->
				<el-table-column prop="specification" label="规格型号" />
				<el-table-column prop="unit" label="单位" />
				<el-table-column prop="unitPrice" label="单价">
					<template #default="scope">
						¥{{ formatAmount(scope.row.unitPrice) }}
					</template>
				</el-table-column>
				<el-table-column prop="costPrice" label="成本价">
					<template #default="scope">
						¥{{ formatAmount(scope.row.costPrice) }}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态">
					<template #default="scope">
						<el-tag :type="scope.row.status === 0 ? 'success' : 'info'">
							{{ scope.row.status === 0 ? '在售' : '停售' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="300">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>
						<el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" :type="scope.row.status === 0 ? 'danger' : 'success'"
							@click="handleToggleStatus(scope.row)">
							{{ scope.row.status === 0 ? '停售' : '上架' }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 产品表单对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-card shadow="never">
			<el-form :model="productForm" :rules="rules" ref="productForm" label-width="100px"
				v-loading="dialogLoading">
				<el-form-item label="产品名称" prop="name">
					<el-col :span="18">
						<el-input v-model="productForm.name" placeholder="请输入产品名称" />
					</el-col>
				</el-form-item>
				<!-- <el-form-item label="产品类型" prop="type">
          <el-select v-model="productForm.type" placeholder="请选择产品类型">
            <el-option label="硬件" value="hardware" />
            <el-option label="软件" value="software" />
            <el-option label="服务" value="service" />
          </el-select>
        </el-form-item> -->
				<el-form-item label="规格型号" prop="specification">
					<el-col :span="18">
						<el-input v-model="productForm.specification" placeholder="请输入规格型号" />
					</el-col>
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="单位" prop="unit">
							<el-input v-model="productForm.unit" placeholder="请输入单位" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item>
							<el-tag @click="productForm.unit='个'">个</el-tag>
							<el-tag @click="productForm.unit='台'">台</el-tag>
							<el-tag @click="productForm.unit='套'">套</el-tag>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="单价" prop="unitPrice">
					<el-input-number v-model="productForm.unitPrice" :min="0" :precision="2" :step="0.01"
						placeholder="请输入单价" />
				</el-form-item>
				<el-form-item label="成本价" prop="costPrice">
					<el-input-number v-model="productForm.costPrice" :min="0" :precision="2" :step="0.01"
						placeholder="请输入成本价" />
				</el-form-item>
				<el-form-item label="产品描述" prop="description">
					<el-col :span="18">
						<el-input v-model="productForm.description" type="textarea" :rows="3" placeholder="请输入产品描述" />
					</el-col>
				</el-form-item>
			</el-form>
			</el-card>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submitForm" :loading="submitLoading">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 查看产品对话框 -->
		<el-dialog title="查看产品" v-model="viewDialogVisible" width="600px">
			<el-descriptions :column="1" border>
				<el-descriptions-item label="产品名称">{{ viewProduct.name }}</el-descriptions-item>
				<!-- <el-descriptions-item label="产品类型">
          <el-tag :type="getProductTypeTag(viewProduct.type)">
            {{ getProductTypeText(viewProduct.type) }}
          </el-tag>
        </el-descriptions-item> -->
				<el-descriptions-item label="规格型号">{{ viewProduct.specification }}</el-descriptions-item>
				<el-descriptions-item label="单位">{{ viewProduct.unit }}</el-descriptions-item>
				<el-descriptions-item label="单价">¥{{ formatAmount(viewProduct.unitPrice) }}</el-descriptions-item>
				<el-descriptions-item label="成本价">¥{{ formatAmount(viewProduct.costPrice) }}</el-descriptions-item>
				<el-descriptions-item label="产品描述">
					<span style="white-space: pre-wrap">{{ viewProduct.description || '无' }}</span>
				</el-descriptions-item>
				<el-descriptions-item label="状态">
					<el-tag :type="viewProduct.status === 0 ? 'success' : 'info'">
						{{ viewProduct.status === 0 ? '在售' : '停售' }}
					</el-tag>
				</el-descriptions-item>
			</el-descriptions>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getProductList,
		addProduct
	} from '@/api/product'
	import {
		Plus,
		Search,
		Refresh
	} from '@element-plus/icons-vue'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'

	export default {
		name: 'ProductManagement',
		components: {
			Plus,
			Search,
			Refresh
		},
		data() {
			return {
				loading: false,
				dialogLoading: false,
				submitLoading: false,
				filterForm: {
					name: '',
					type: ''
				},
				productList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				dialogTitle: '添加产品',
				viewProduct: {},
				productForm: {
					name: '',
					type: '',
					specification: '',
					unit: '',
					unitPrice: 0,
					costPrice: 0,
					description: '',
					status: 0
				},
				rules: {
					name: [{
						required: true,
						message: '请输入产品名称',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择产品类型',
						trigger: 'change'
					}],
					specification: [{
						required: true,
						message: '请输入规格型号',
						trigger: 'blur'
					}],
					unit: [{
						required: true,
						message: '请输入单位',
						trigger: 'blur'
					}],
					unitPrice: [{
						required: true,
						message: '请输入单价',
						trigger: 'blur'
					}],
					costPrice: [{
						required: true,
						message: '请输入成本价',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.fetchData()
		},
		methods: {
			async fetchData() {
				this.loading = true
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getProductList(params)
					this.productList = res.data.records
					this.total = res.data.total
				} catch (error) {
					console.error('获取产品列表失败:', error)
					ElMessage.error('获取产品列表失败')
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					name: '',
					type: ''
				}
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			handleAdd() {
				this.dialogTitle = '添加产品'
				this.productForm = {
					name: '',
					type: '',
					specification: '',
					unit: '',
					unitPrice: 0,
					costPrice: 0,
					description: '',
					status: 0
				}
				this.dialogVisible = true
			},
			handleView(row) {
				this.viewProduct = {
					...row
				}
				this.viewDialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑产品'
				this.productForm = {
					...row
				}
				this.dialogVisible = true
			},
			async handleToggleStatus(row) {
				try {
					await ElMessageBox.confirm(
						`确认${row.status === 0 ? '停售' : '上架'}该产品吗？`,
						'提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					)
					const newStatus = row.status === 0 ? 1 : 0
					this.productForm = row;
					this.productForm.status = newStatus;
					// this.productForm.id = row.id;
					await addProduct(this.productForm)
					ElMessage.success(`${newStatus === 0 ? '上架' : '停售'}成功`)
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('切换产品状态失败:', error)
						ElMessage.error('操作失败')
					}
				}
			},
			async submitForm() {
				try {
					await this.$refs.productForm.validate()
					this.submitLoading = true
					if (this.productForm.id) {
						await addProduct(this.productForm)
						ElMessage.success('更新成功')
					} else {
						await addProduct(this.productForm)
						ElMessage.success('添加成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交表单失败:', error)
				} finally {
					this.submitLoading = false
				}
			},
			getProductTypeTag(type) {
				const typeMap = {
					hardware: 'primary',
					software: 'success',
					service: 'warning'
				}
				return typeMap[type] || 'info'
			},
			getProductTypeText(type) {
				const typeMap = {
					hardware: '硬件',
					software: '软件',
					service: '服务'
				}
				return typeMap[type] || type
			},
			formatAmount(amount) {
				return amount ? amount.toFixed(2) : '0.00'
			}
		}
	}
</script>

<style scoped>

</style>